module.exports = __webpack_public_path__ + "static/media/yhq-deep.9ce3fab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yhq-deep.png
// module id = 2169
// module chunks = 4